import http from "../httpservices/HttpService"

export default {
  login({commit}, user) {
    return new Promise((resolve, reject) => {
      commit("auth_request");
      http.post("/Auth/login", {
          countryCode: user.countryCode,
          number: user.phoneNumber,
          password: user.password,
        },
      )
        .then(function (response) {
          //if response is successful get the following data from server
          //const status = response.data.info.status
          const token = response.data.accessToken;

          localStorage.setItem("tempToken", token);
          // localStorage.setItem('tokenExpire', response.data.expires)

          //The following line has been commented because it might cause problem if you are setting
          //axios.defaults.headers.common['Authorization'] = token
          // var result = { "token": token };

          // commit("set_profile", user);

          // commit('auth_success', result)
          resolve(response);
        })
        .catch((err) => {
          console.log(err.response);
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });


    });
  },

  loginToken({commit}, {MFAData}) {
    return new Promise((resolve, reject) => {
      commit("auth_request");

      let headers = {};


      if (MFAData.MFA_SMS != undefined && MFAData.MFA_SMS != "") {
        headers['mfa-sms'] = MFAData.MFA_SMS;
      }
      if (MFAData.MFA_EMAIL != undefined && MFAData.MFA_EMAIL != "") {
        headers['mfa-email'] = MFAData.MFA_EMAIL;
      }
      if (MFAData.MFA_TOTP !== undefined && MFAData.MFA_TOTP !== "") {
        headers['mfa-totp'] = MFAData.MFA_TOTP;
      }

      http.post("/Auth/login/token", {}, {
        headers,
      })
        .then(function (response) {
          //if response is successful get the following data from server
          //const status = response.data.info.status
          const token = response.data.accessToken;
          const role = response.data.role;
          localStorage.removeItem("tempToken");

          localStorage.setItem("token", token);
          localStorage.setItem("role", role);
          localStorage.setItem("tokenExpire", response.data.expires);

          //The following line has been commented because it might cause problem if you are setting
          //axios.defaults.headers.common['Authorization'] = token
          const result = {token: token};

          commit("auth_success", result);

          resolve(response);
        })
        .catch((err) => {
          console.log(err.response);
          commit("auth_error");
          localStorage.removeItem("token");
          reject(err);
        });
    });
  },

  addConfiguration({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/botconfig/", {
        channel_top: data.channel_top,
        channel_width: data.channel_width,
        currency_pair: data.currency_pair,
        is_started: data.is_started,
        min_distance: data.min_distance,
        order_interval: data.order_interval,
        order_size: data.order_size,
        side: data.side,
        take_profit: data.take_profit,
        stop_loss: data.stop_loss,
        is_confirmed: false,
      })
        .then(function (response) {
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  stopConfiguration({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/botconfig/stop?bot_config_id=" + data)
        .then(function (response) {
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  changeConfiguration({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/botconfig/edit?bot_config_id=" + data.id, {
        channel_top: data.channel_top,
        channel_width: data.channel_width,
        currency_pair: data.currency_pair,
        is_started: data.is_started,
        min_distance: data.min_distance,
        order_interval: data.order_interval,
        order_size: data.order_size,
        side: data.side,
        take_profit: data.take_profit,
        stop_loss: data.stop_loss,
        is_confirmed: false,
      })
        .then(function (response) {
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  changePassword({commit}, data) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem('token')
      http.post("/reset-password/", {
        token: token,
        new_password: data.new_pass,
      },)
        .then(function (response) {
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  createUser({commit}, data) {
    return new Promise((resolve, reject) => {

      http.post("/users/", {
        email: data.email,
        full_name: data.full_name,
        password: data.password,
        is_active: data.is_active,
        is_superuser: data.is_superuser,
      },)
        .then(function (response) {
          console.log(response);
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  updateUser({commit}, data) {
    return new Promise((resolve, reject) => {

      http.patch("/Accounts/" + data.id, {
        firstName: data.firstName,
        lastName: data.lastName,
        nationalCode: data.nationalCode,
        birthDate: data.birthDate,
        landlineCountryCode: data.landlineCountryCode,
        landlineNumber: data.landlineNumber,
        email: data.email,
        role: data.role,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          console.log(error);
          resolve(error);
        });
    });
  },

  setIrtUsdtPrice({commit}, data) {
    return new Promise((resolve, reject) => {

      http.post('/Configs/irtusdt', {
        value: data.data,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  setUsdtIrtPrice({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/Configs/usdtirt", {
        value: data.data,
      },)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  setPmIrtPrice({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/Configs/irtusdt",   {
        value: data.data,
      },)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  setPmvIrtPrice({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/Configs/irtusdt", {
        value: data.data,
      },)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  setServiceFee({commit}, data) {
    return new Promise((resolve, reject) => {
      http.post("/Configs/servicefee", {
        value: data.data,
      })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  createTicket({commit}, data) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("token") || "";

      const form = new FormData();
      form.append("department", data.department);
      form.append("priority", data.priority);
      form.append("subject", data.subject);
      form.append("message", data.message);
      form.append("attached", data.attached);

      axios
        .post(
          process.env.VUE_APP_TICKETSERVICE_URL + "/api/tickets/create",
          form,
          {
            crossDomain: true,
            headers: {
              "content-type":
                "multipart/form-data; boundary=---011000010111000001101001",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  replyTicket({commit}, data) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("token") || "";

      const form = new FormData();
      form.append("message", data.message);
      form.append("attached", data.attached);

      axios
        .post(
          process.env.VUE_APP_TICKETSERVICE_URL +
          "/api/tickets/uid/" +
          data.uid +
          "/reply",
          form,
          {
            crossDomain: true,
            headers: {
              "content-type":
                "multipart/form-data; boundary=---011000010111000001101001",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  closeTicket({commit}, data) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("token") || "";

      axios
        .patch(
          process.env.VUE_APP_TICKETSERVICE_URL +
          "/api/tickets/uid/" +
          data.uid,
          {
            status: data.status,
          },
          {
            crossDomain: true,
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  createDepartment({commit}, data) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("token") || "";

      const form = new FormData();
      form.append("title", data.title);
      form.append("description", data.description);

      axios
        .post(
          process.env.VUE_APP_TICKETSERVICE_URL + "/api/departments/create",
          {
            title: data.title,
            description: data.description,
          },
          {
            crossDomain: true,
            headers: {
              Authorization: "Bearer " + token,
            },
          }
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  deleteDepartment({commit}, data) {
    return new Promise((resolve, reject) => {
      http.delete("/api/departments/uid/" + data.uid, {
        baseURL: process.env.VUE_APP_TICKETSERVICE_URL
      })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          console.log(err);
          //commit('auth_error')
          // localStorage.removeItem('token')

          reject(err);
        });
    });
  },

  logout({commit}) {
    return new Promise((resolve) => {
      commit("logout");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenExpire");
      localStorage.removeItem("email");
      localStorage.removeItem("role");
      localStorage.removeItem("user");
      localStorage.removeItem("register-email");
      localStorage.removeItem("register-temporaryPassword");
      resolve("done");
    });
  },

  async getAssets(context) {
    try {
      const response = await http.get(process.env.VUE_APP_RESOURCE_URL + "/Assets/list");
      if (response.status === 200) {
        context.commit("setAssets", Object.values(response.data.coins));
      }
    } catch (err) {
      console.log(err.response);
    }
  },

  async getRoles(context) {
    try {
      const response = await http.get("/Accounts/role");

      if (response.status === 200) {
        context.commit("setRoles", response.data);
      }
    } catch (err) {
      console.log(err.response);
    }
  }

};
